import { Request } from "../../utils/request";

export const read = () =>
  Request({ withToken: true }).get("/machine-operation-rates");

export const deleteOne = (id: string) =>
  Request({ withToken: true }).delete(`/machine-operation-rates/${id}`);
